import { Injectable, OnDestroy } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TokenChangeService implements OnDestroy {
  private tokenChangeSubject: Subject<void> = new Subject<void>();

  constructor() {
    window.addEventListener('storage', this.onStorageChange.bind(this));
  }

  ngOnDestroy() {
    window.removeEventListener('storage', this.onStorageChange.bind(this));
  }

  private onStorageChange(event: StorageEvent) {
    if (event.key === 'token') {
      this.tokenChangeSubject.next();
    }
  }

  getTokenChangeObservable(): Observable<void> {
    return this.tokenChangeSubject.asObservable();
  }
}
